var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGerarSenha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.03 0 3 4.03 3 9H0L4 13L8 9H5C5 5.14 8.14 2 12 2C15.86 2 19 5.14 19 9C19 12.86 15.86 16 12 16C10.1 16 8.38 15.24 7.12 14.01L5.7 15.42C7.32 17.01 9.55 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0ZM14 8V7C14 5.9 13.1 5 12 5C10.9 5 10 5.9 10 7V8C9.45 8 9 8.45 9 9V12C9 12.55 9.45 13 10 13H14C14.55 13 15 12.55 15 12V9C15 8.45 14.55 8 14 8ZM13 8H11V7C11 6.45 11.45 6 12 6C12.55 6 13 6.45 13 7V8Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerarSenha);
export default __webpack_public_path__ + "static/media/gerar-senha.28ec9afcf1c606aecfa3442cd7b763c5.svg";
export { ForwardRef as ReactComponent };